import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

type LogoColor = 'white' | 'black';

const logoColor: Record<LogoColor, string> = {
	white: './assets/images/general/Recurso 60.png',
	black: './assets/images/general/LogoNaranja.png',
};

@Component({
	selector: 'cmv-toolbar-base',
	templateUrl: './toolbar-base.component.html',
	styleUrls: ['./toolbar-base.component.scss'],
})
export class ToolbarBaseComponent {
	@Input() backgroungColor: string = 'var(--primary-color)';
	@Input() showBackButton: boolean;
	@Input() mobileLogoColor: LogoColor = 'black';
	@Input() desktopLogoColor: LogoColor = 'black';
	@Input() logoSrc: string = null;
	@Output() backEvent: EventEmitter<void> = new EventEmitter();
	constructor() {}

	onBack(): void {
		this.backEvent.emit();
	}

	get mobileImageSrc(): string {
		return this.logoSrc ?? logoColor[this.mobileLogoColor];
	}

	get desktopImageSrc(): string {
		return this.logoSrc ?? logoColor[this.desktopLogoColor];
	}
}
